import api from "@/libs/axios";
import * as ep from "./endpoint";

export default {
  namespaced: true,

  state: () => ({
    typeCirclars: [],
    circlars: [],
    loading: false,
    loadingCirclars: false,
    nameCirclars: "",
    pagination: {},
  }),
  getters: {
    typeCirclars(state) {
      return state.typeCirclars;
    },
    nameCirclars(state) {
      return state.nameCirclars;
    },
    circlars(state) {
      return state.circlars;
    },
    loading(state) {
      return state.loading;
    },
    loadingCirclars(state) {
      return state.loadingCirclars;
    },
    pagination(state) {
      return state.pagination;
    },
  },
  mutations: {
    setTypeCirclars(state, payload) {
      state.typeCirclars = payload;
    },
    setCirclars(state, payload) {
      state.circlars = payload;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    },
  },
  actions: {
    getTypeCirclars(context, payload) {
      context.state.loading = true;
      api
        .get(ep.TYPECIRCLARS, {
          params: { page: payload.page, name: payload.name },
        })
        .then((res) => {
          context.commit("setTypeCirclars", res.data.data);
          context.commit("setPagination", res.data.pagination);
          context.state.loading = false;
        });
    },
    getCirclars(context, payload) {
      context.state.loadingCirclars = true;
      api
        .get(ep.CIRCLARS(payload.id))
        .then((res) => {
          context.commit("setCirclars", res.data.data.regulations);
          context.state.nameCirclars = res.data.data.name_ar;
          context.state.loadingCirclars = false;
        })
        .catch(() => {
          context.state.loadingCirclars = false;
        });
    },
  },
};
